import React from 'react';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CancelIcon from '@mui/icons-material/Cancel';

export function YearPickerInput({
  label,
  isRequired,
  value,
  placeholder = "--Select Year--",
  error,
  errorMessage,
  onSelectClick,
  onClearClick,
  hasSelection,
  disabled
}) {
  return (
    <div className="mb-1 w-full">
      {label && (
        <label className="mb-1.5 block text-sm font-medium text-gray-600">
          {label}
          {isRequired && <span className="ml-1 text-red-500">*</span>}
        </label>
      )}

      <div className="flex flex-row items-center">
        <input
          type="text"
          placeholder={placeholder}
          value={value || ""}
          readOnly
          disabled={disabled}
          className={`w-full border border-solid border-gray-300 rounded-l-md px-3 py-2 text-gray-600 placeholder-gray-400 ${disabled ? 'bg-gray-100' : 'bg-white'} ${error ? 'border-red-500' : ''}`}
        />
        {!disabled && (
          !hasSelection ? (
            <button
              type="button"
              className="flex items-center rounded-r-md border-none bg-sky-400 hover:bg-sky-500 text-white h-[33px] cursor-pointer px-3"
              onClick={onSelectClick}
            >
              <CalendarTodayIcon/>
            </button>
          ) : (
            <button
              type="button"
              className="flex items-center rounded-r-md border-none bg-red-400 hover:bg-red-500 text-white h-[33px] cursor-pointer px-3"
              onClick={onClearClick}
            >
              <CancelIcon/>
            </button>
          )
        )}
      </div>
      {error && errorMessage && (
        <span className="mt-1 block text-sm text-red-500">{errorMessage}</span>
      )}
    </div>
  );
}